<template>
  <div class="user-management">
    <el-tabs v-model="mainTab" class="user-main-tabs lvyun-tabs" @tab-click="onMainTabClick">
      <el-tab-pane label="客户查询" name="customers">
        <el-card shadow="hover">
      <template slot="header">
        <div class="card-header">
          <span>客户查询</span>
          <div class="right-actions">
            <el-button type="primary" size="small" class="btn-primary" icon="el-icon-plus" @click="openAddCustomer">
              添加客户
            </el-button>
            <el-input
              v-model="searchKeyword"
              placeholder="按姓名/手机号搜索"
              clearable
              size="small"
              style="width: 220px; margin-right: 10px;"
            />
            <el-button type="primary" size="small" @click="exportToExcel">导出Excel</el-button>
            <el-button type="primary" plain size="small" @click="downloadTemplate">下载模板</el-button>
            <el-upload
              action="#"
              :show-file-list="false"
              :before-upload="handleImport"
              accept=".csv,.xls,.xlsx"
            >
              <el-button size="small">导入Excel</el-button>
            </el-upload>
          </div>
        </div>
      </template>
      <div class="user-table-wrapper">
        <el-table
          ref="userTable"
          :data="pagedUsers"
          border
          stripe
          header-align="center"
          align="center"
          class="user-data-table"
          style="width: 100%"
        >
          <el-table-column
            type="index"
            label="序号"
            width="64"
            align="center"
            fixed="left"
            :index="customerIndexMethod"
          />
          <el-table-column
            prop="id"
            label="用户ID"
            width="160"
            align="center"
            fixed="left"
            show-overflow-tooltip
            class-name="col-user-id"
          />
          <el-table-column
            prop="username"
            label="姓名"
            width="110"
            align="center"
            fixed="left"
            show-overflow-tooltip
          />
          <el-table-column
            label="手机号"
            width="128"
            align="center"
            fixed="left"
            class-name="col-phone-multiline"
          >
            <template slot-scope="scope">
              <div class="phone-cell">
                <div v-for="(p, i) in phoneLines(scope.row.phone)" :key="i">{{ p }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="subscriptionType" label="套餐类型" width="100" align="center" show-overflow-tooltip />
          <el-table-column prop="subscriptionCount" label="套餐数量" width="90" align="center" />
          <el-table-column prop="subscriptionTimes" label="套餐次数" width="90" align="center" />
          <el-table-column prop="orderStatus" label="订单状态" width="110" align="center" show-overflow-tooltip />
          <el-table-column prop="lastOrderTime" label="下单时间" width="168" align="center" show-overflow-tooltip />
          <el-table-column prop="orderChannel" label="下单方式" width="110" align="center" show-overflow-tooltip />
          <el-table-column prop="orderAmount" label="金额" width="90" align="center" />
          <el-table-column prop="orderRemark" label="订单备注" min-width="140" align="center" show-overflow-tooltip />
          <el-table-column prop="address" label="收货地址" min-width="200" align="center" show-overflow-tooltip />
          <el-table-column label="兑换券" min-width="160" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.vouchers && scope.row.vouchers.length">
                {{ scope.row.vouchers.map(v => v.code).join('、') }}
              </span>
              <span v-else class="text-gray">无兑换券</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="168" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="btn-secondary"
                @click="editUser(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                size="mini"
                class="btn-secondary danger"
                @click="deleteUser(scope.row.id)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <admin-pagination
        :total="filteredUsers.length"
        :page.sync="currentPage"
        :page-size.sync="pageSize"
        @change="onCustomerPaginationChange"
      />
    </el-card>
    
    <!-- 用户兑换券详情对话框 -->
    <el-dialog :title="currentUser.username + '的兑换券'" :visible.sync="voucherDialogVisible" width="600px">
      <el-table :data="currentUserVouchers" style="width: 100%">
        <el-table-column prop="code" label="兑换码"></el-table-column>
        <el-table-column prop="value" label="价值"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag :type="getVoucherStatusType(scope.row.status)">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="exchange_product" label="兑换商品">
          <template slot-scope="scope">
            <span>{{ scope.row.exchange_product || '未兑换' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="expiry_date" label="过期日期"></el-table-column>
        <el-table-column prop="createdAt" label="创建时间">
          <template slot-scope="scope">{{ $formatDateTime(scope.row.createdAt) }}</template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="voucherDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 编辑用户信息对话框 -->
    <el-dialog title="编辑用户信息" :visible.sync="editDialogVisible" width="500px">
      <el-form :model="editForm" label-width="90px">
        <el-form-item label="姓名">
          <el-input v-model="editForm.username" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="editForm.phone" />
        </el-form-item>
        <el-form-item label="收货地址">
          <el-input v-model="editForm.address" />
        </el-form-item>
        <el-form-item label="订单备注">
          <el-input type="textarea" :rows="3" v-model="editForm.orderRemark" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="添加客户" :visible.sync="addDialogVisible" width="480px" @closed="resetAddForm">
      <el-form :model="addForm" label-width="90px">
        <el-form-item label="姓名">
          <el-input v-model="addForm.username" placeholder="选填，可与手机号二选一" clearable />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="addForm.phone" placeholder="选填" clearable maxlength="11" />
        </el-form-item>
        <el-form-item label="收货地址">
          <el-input v-model="addForm.address" type="textarea" :rows="2" placeholder="选填" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addForm.remark" type="textarea" :rows="2" placeholder="选填" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="addSubmitting" @click="submitAddCustomer">确定</el-button>
      </span>
    </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="用户等级管理" name="levels" lazy>
        <user-level-management :embedded="true" :customer-users="users" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import UserLevelManagement from './UserLevelManagement.vue'
import AdminPagination from '../components/AdminPagination.vue'
import { formatDateTime, formatDate } from '../utils/dateTimeUtils'
import { triggerBlobDownload } from '../utils/fileExport'
import { guardUploadFile, validateCsvText } from '../utils/fileImport'
import { DEFAULT_PAGE_SIZE } from '../utils/pagination'

export default {
  name: 'UserManagement',
  components: { UserLevelManagement, AdminPagination },
  data() {
    return {
      mainTab: 'customers',
      addDialogVisible: false,
      addSubmitting: false,
      addForm: {
        username: '',
        phone: '',
        address: '',
        remark: ''
      },
      users: [],
      currentUser: {},
      currentUserVouchers: [],
      voucherDialogVisible: false,
      searchKeyword: '',
      currentPage: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      editDialogVisible: false,
      editForm: {
        id: null,
        username: '',
        phone: '',
        address: '',
        orderRemark: ''
      },
      currentEditIndex: -1
    }
  },
  computed: {
    filteredUsers() {
      const kw = this.searchKeyword.trim();
      if (!kw) return this.users;
      return this.users.filter(u =>
        (u.username && u.username.includes(kw)) ||
        this.phoneMatchesKeyword(u.phone, kw)
      );
    },
    pagedUsers() {
      const list = this.filteredUsers
      const start = (this.currentPage - 1) * this.pageSize
      return list.slice(start, start + this.pageSize)
    }
  },
  mounted() {
    this.syncMainTabFromRoute()
    this.getUsers()
    this._onResizeLayout = () => this.relayoutUserTable()
    window.addEventListener('resize', this._onResizeLayout)
  },
  beforeDestroy() {
    if (this._onResizeLayout) {
      window.removeEventListener('resize', this._onResizeLayout)
    }
  },
  watch: {
    '$route.query.tab'(v) {
      this.mainTab = v === 'levels' ? 'levels' : 'customers'
      if (this.mainTab === 'customers') {
        this.$nextTick(() => this.relayoutUserTable())
      }
    },
    mainTab(v) {
      if (v === 'customers') {
        this.$nextTick(() => this.relayoutUserTable())
      }
    },
    searchKeyword() {
      this.currentPage = 1
      this.$nextTick(() => this.relayoutUserTable())
    }
  },
  methods: {
    onCustomerPaginationChange({ page, pageSize }) {
      this.currentPage = page
      this.pageSize = pageSize
      this.$nextTick(() => this.relayoutUserTable())
    },
    customerIndexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    },
    relayoutUserTable() {
      this.$nextTick(() => {
        const t = this.$refs.userTable
        if (t && typeof t.doLayout === 'function') {
          t.doLayout()
        }
      })
    },
    phoneLines(phone) {
      if (phone == null || String(phone).trim() === '') return ['—']
      const parts = String(phone)
        .split(/\s*\/\s*/)
        .map((s) => s.trim())
        .filter(Boolean)
      return parts.length ? parts : ['—']
    },
    phoneMatchesKeyword(phone, kw) {
      if (!kw) return false
      if (!phone) return false
      if (String(phone).includes(kw)) return true
      return String(phone)
        .split(/\s*\/\s*/)
        .some((p) => p.trim().includes(kw))
    },
    syncMainTabFromRoute() {
      this.mainTab = this.$route.query.tab === 'levels' ? 'levels' : 'customers'
    },
    onMainTabClick(tab) {
      const name = tab.name
      if (name === 'levels') {
        this.$router.replace({ path: '/users', query: { tab: 'levels' } }).catch(() => {})
      } else {
        this.$router.replace({ path: '/users', query: {} }).catch(() => {})
      }
    },
    openAddCustomer() {
      this.resetAddForm()
      this.addDialogVisible = true
    },
    resetAddForm() {
      this.addForm = { username: '', phone: '', address: '', remark: '' }
    },
    async submitAddCustomer() {
      const username = (this.addForm.username || '').trim()
      const phone = (this.addForm.phone || '').trim()
      if (!username && !phone) {
        this.$message.warning('请填写姓名或手机号')
        return
      }
      this.addSubmitting = true
      try {
        const resp = await this.$api.post('/admin/users', {
          username,
          phone,
          address: this.addForm.address || '',
          remark: this.addForm.remark || ''
        })
        if (resp && (resp.code === 200 || resp.code === 201)) {
          this.$message.success('客户添加成功')
          this.addDialogVisible = false
          await this.getUsers()
        } else {
          this.$message.error((resp && resp.message) || '添加失败')
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e._networkHint) ||
          '添加失败'
        this.$message.error(msg)
      } finally {
        this.addSubmitting = false
      }
    },
    async getUsers() {
      const fmtDt = (d) => {
        const s = formatDateTime(d)
        return s === '—' ? '' : s
      }
      const fmtD = (d) => {
        const s = formatDate(d)
        return s === '—' ? '' : s
      }

      try {
        const [usersResp, ordersResp, vouchersResp] = await Promise.all([
          this.$api.get('/admin/users'),
          this.$api.get('/admin/orders'),
          this.$api.get('/admin/vouchers')
        ])

        const users = (usersResp && usersResp.code === 200) ? (usersResp.data || []) : []
        const orders = (ordersResp && ordersResp.code === 200) ? (ordersResp.data || []) : []
        const vouchers = (vouchersResp && vouchersResp.code === 200) ? (vouchersResp.data || []) : []

        const vouchersByUserId = {}
        for (const v of vouchers) {
          const uid = v.user_id && (v.user_id._id || v.user_id.id || v.user_id)
          const key = uid ? String(uid) : ''
          if (!key) continue
          if (!vouchersByUserId[key]) vouchersByUserId[key] = []
          vouchersByUserId[key].push({
            code: v.code,
            value: v.value,
            status: v.status,
            exchange_product: v.product_name || '',
            expiry_date: fmtD(v.expiry_date),
            createdAt: fmtDt(v.created_at)
          })
        }

        const ordersByUserId = {}
        for (const o of orders) {
          const uid = o.user_id && (o.user_id._id || o.user_id.id || o.user_id)
          const key = uid ? String(uid) : ''
          if (!key) continue
          if (!ordersByUserId[key]) ordersByUserId[key] = []
          ordersByUserId[key].push(o)
        }

        const itemLineLabel = (it) => {
          if (!it) return ''
          const n =
            (it.product_id && typeof it.product_id === 'object' && it.product_id.name)
              ? it.product_id.name
              : (it.name || '')
          const q = Number(it.quantity) || 0
          if (!n) return ''
          return q ? `${n}×${q}` : n
        }

        const orderProductTypeLabel = (order) => {
          if (!order || !Array.isArray(order.items) || !order.items.length) {
            return order && order.order_type === '随心订' ? '随心订' : (order && order.order_type) || ''
          }
          const parts = order.items.map(itemLineLabel).filter(Boolean)
          return parts.join(' + ') || (order.order_type || '')
        }

        const orderItemsQtySum = (order) => {
          if (!order || !Array.isArray(order.items)) return 0
          let s = order.items.reduce((a, it) => a + (Number(it.quantity) || 0), 0)
          if (!s && order.items[0]) s = Number(order.items[0].quantity) || 1
          return s
        }

        const pickBestSuiXinDing = (userIds) => {
          let best = null
          let bestT = 0
          for (const uid of userIds) {
            for (const o of ordersByUserId[uid] || []) {
              if (String(o.order_type || '') !== '随心订') continue
              const t = new Date(o.created_at || 0).getTime()
              if (t >= bestT) {
                bestT = t
                best = o
              }
            }
          }
          return best
        }

        const latestOrderAny = (userIds) => {
          let best = null
          let bestT = 0
          for (const uid of userIds) {
            for (const o of ordersByUserId[uid] || []) {
              const t = new Date(o.created_at || 0).getTime()
              if (t >= bestT) {
                bestT = t
                best = o
              }
            }
          }
          return best
        }

        const maxLastOrderTimeStr = (userIds) => {
          let maxT = 0
          let s = ''
          for (const uid of userIds) {
            for (const o of ordersByUserId[uid] || []) {
              const t = new Date(o.created_at || 0).getTime()
              if (t > maxT) {
                maxT = t
                s = fmtDt(o.created_at)
              }
            }
          }
          return s
        }

        const baseRows = users.map((u) => {
          const rawId = u.id != null && u.id !== '' ? u.id : u._id
          const userId = rawId != null && rawId !== '' ? String(rawId) : ''
          const userOrders = ordersByUserId[userId] || []
          const lastOrder = userOrders
            .slice()
            .sort((a, b) => new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime())[0] || null
          const firstItem = lastOrder && Array.isArray(lastOrder.items) && lastOrder.items.length ? lastOrder.items[0] : null

          return {
            id: rawId,
            username: u.username || '',
            phone: u.phone || '',
            address: u.address || '',
            subscriptionType: lastOrder ? (lastOrder.order_type || '') : '',
            subscriptionCount: firstItem ? (firstItem.quantity || 0) : 0,
            subscriptionTimes: '',
            orderStatus: lastOrder ? (lastOrder.order_status || '') : '',
            orderChannel: lastOrder ? (lastOrder.order_type === '随心订' ? '随心订小程序' : '') : '',
            orderAmount: lastOrder ? (lastOrder.total_price || 0) : 0,
            orderRemark: lastOrder ? (lastOrder.remark || '') : '',
            lastOrderTime: lastOrder ? fmtDt(lastOrder.created_at) : '',
            vouchers: vouchersByUserId[userId] || []
          }
        })

        const nameGroups = new Map()
        const noNameRows = []
        for (const row of baseRows) {
          const nk = (row.username || '').trim()
          if (!nk) {
            noNameRows.push({ ...row, mergedUserIds: [String(row.id)] })
            continue
          }
          if (!nameGroups.has(nk)) nameGroups.set(nk, [])
          nameGroups.get(nk).push(row)
        }

        const mergePhones = (rows) => {
          const s = new Set()
          rows.forEach((x) => {
            if (x.phone) s.add(String(x.phone).trim())
          })
          return Array.from(s).join(' / ')
        }

        const merged = [...noNameRows]
        for (const group of nameGroups.values()) {
          if (group.length === 1) {
            merged.push({ ...group[0], mergedUserIds: [String(group[0].id)] })
            continue
          }
          const mergedUserIds = group.map((g) => String(g.id))
          const sxOrder = pickBestSuiXinDing(mergedUserIds)
          const lastAny = latestOrderAny(mergedUserIds)
          const refOrder = sxOrder || lastAny
          const vouchersMerged = mergedUserIds.flatMap((uid) => vouchersByUserId[uid] || [])
          const primary = group[0]
          merged.push({
            ...primary,
            id: primary.id,
            phone: mergePhones(group),
            address: group.map((g) => g.address).find((a) => a && String(a).trim()) || primary.address,
            subscriptionType: refOrder ? orderProductTypeLabel(refOrder) : '',
            subscriptionCount: refOrder ? orderItemsQtySum(refOrder) : 0,
            subscriptionTimes: '',
            orderStatus: refOrder ? (refOrder.order_status || '') : '',
            orderChannel: refOrder && refOrder.order_type === '随心订' ? '随心订小程序' : (refOrder ? '' : ''),
            orderAmount: refOrder ? (refOrder.total_price || 0) : 0,
            orderRemark: refOrder ? (refOrder.remark || '') : '',
            lastOrderTime: maxLastOrderTimeStr(mergedUserIds),
            vouchers: vouchersMerged,
            mergedUserIds
          })
        }

        this.users = merged
        this.currentPage = 1

        localStorage.setItem('dashboard_user_count', String(this.users.length))
        this.relayoutUserTable()
      } catch (e) {
        this.users = []
        this.currentPage = 1
        localStorage.setItem('dashboard_user_count', '0')
        this.relayoutUserTable()
      }
    },
    exportToExcel() {
      const header = ['序号','用户ID','姓名','手机号','套餐类型','套餐数量','套餐次数','订单状态','下单时间','下单方式','金额','订单备注','收货地址'];
      const rows = this.filteredUsers.map((u, index) => [
        index + 1,
        u.id || '',
        u.username || '',
        (u.phone || '').replace(/\s*\/\s*/g, '\n'),
        u.subscriptionType || '',
        u.subscriptionCount || '',
        u.subscriptionTimes || '',
        u.orderStatus || '',
        u.lastOrderTime || '',
        u.orderChannel || '',
        u.orderAmount || '',
        (u.orderRemark || '').toString().replace(/"/g, '""'),
        (u.address || '').toString().replace(/"/g, '""')
      ]);
      const csv = [header.join(','), ...rows.map(r => r.map(v => `"${v}"`).join(','))].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      triggerBlobDownload(blob, '顾客查询_导出', 'csv');
      this.$message.success('导出成功，请在浏览器下载中查看。');
    },
    downloadTemplate() {
      const header = ['序号','用户ID','姓名','手机号','套餐类型','套餐数量','套餐次数','订单状态','下单时间','下单方式','金额','订单备注','收货地址'];
      const csv = header.join(',') + '\n';
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      triggerBlobDownload(blob, '顾客查询_模板', 'csv');
      this.$message.success('模板已下载。');
    },
    handleImport(file) {
      if (!guardUploadFile(this, file, { allowCsv: true })) return false;
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const validated = validateCsvText(text, { expectedMinCols: 4 });
        if (!validated.ok) {
          this.$message.error(validated.message);
          return;
        }
        const lines = validated.lines;
        // 跳过首行表头
        const imported = lines.slice(1).map((line, idx) => {
          const cols = line.split(',').map(c => c.replace(/^"|"$/g, '').replace(/""/g, '"'));
          return {
            id: idx + 1,
            username: cols[2] || '',
            phone: cols[3] || '',
            subscriptionType: cols[4] || '',
            subscriptionCount: cols[5] || '',
            subscriptionTimes: cols[6] || '',
            orderStatus: cols[7] || '',
            lastOrderTime: cols[8] || '',
            orderChannel: cols[9] || '',
            orderAmount: cols[10] || '',
            orderRemark: cols[11] || '',
            address: cols[12] || '',
            vouchers: []
          };
        });
        this.users = imported;
        this.$message.success('导入成功');
        localStorage.setItem('dashboard_user_count', String(this.users.length));
      };
      reader.readAsText(file, 'utf-8');
      return false; // 阻止自动上传
    },
    viewUserVouchers(user) {
      this.currentUser = user;
      this.currentUserVouchers = user.vouchers || [];
      this.voucherDialogVisible = true;
    },
    getVoucherStatusType(status) {
      switch (status) {
        case '未使用': return 'primary';
        case '使用中': return 'warning';
        case '已用完': return 'success';
        case '已过期': return 'danger';
        default: return '';
      }
    },
    editUser(user) {
      this.currentEditIndex = this.users.findIndex(u => u.id === user.id);
      if (this.currentEditIndex < 0) return;
      const u = this.users[this.currentEditIndex];
      this.editForm = {
        id: u.id,
        username: u.username,
        phone: u.phone,
        address: u.address,
        orderRemark: u.orderRemark
      };
      this.editDialogVisible = true;
    },
    submitEdit() {
      if (this.currentEditIndex < 0) return;
      const id = this.editForm.id
      const payload = {
        username: this.editForm.username,
        phone: this.editForm.phone,
        address: this.editForm.address
      }
      this.$api
        .put(`/admin/users/${id}`, payload)
        .then(() => {
          this.$message.success('用户信息已更新');
          this.editDialogVisible = false;
          this.getUsers();
        })
        .catch(() => {
          this.$message.error('用户更新失败');
        });
    },
    deleteUser(userId) {
      this.$confirm('确定要删除该用户吗？', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api
          .delete(`/admin/users/${userId}`)
          .then(() => {
            this.$message.success('用户已删除');
            this.getUsers();
          })
          .catch(() => {
            this.$message.error('用户删除失败');
          })
      }).catch(() => {});
    }
  }
}
</script>

<style scoped>
.user-management {
  padding: 20px;
}

.user-main-tabs ::v-deep .el-tabs__header {
  margin-bottom: 16px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.right-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

/* 交给 el-table 自身横向滚动，避免外层 overflow 导致表头/表体错位 */
.user-table-wrapper {
  width: 100%;
  overflow: hidden;
}

.text-gray {
  color: #999;
}
</style>

<style>
.user-table-wrapper .user-data-table {
  width: 100% !important;
}
.user-table-wrapper .el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 22px;
}
.user-table-wrapper .el-table td.col-phone-multiline .cell {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  line-height: 1.45;
}
.user-table-wrapper .el-table td.col-user-id .cell {
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-table-wrapper .el-table .phone-cell {
  line-height: 1.45;
  word-break: break-all;
}
/* 固定列阴影，滚动时仍能辨认对齐 */
.user-table-wrapper .el-table__fixed,
.user-table-wrapper .el-table__fixed-right {
  box-shadow: 2px 0 8px rgba(15, 23, 42, 0.06);
}
.user-table-wrapper .el-table__fixed-right {
  box-shadow: -2px 0 8px rgba(15, 23, 42, 0.06);
}
</style>